// src/context/PermissionContext.jsx
import React, { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';
import API_BASE_URL from '../config/api';

const PermissionContext = createContext({ permissions: [], can: () => false, refresh: () => {} });

// Provider: โหลดสิทธิ์ของผู้ใช้จาก /api/users/me แล้วให้ทุกหน้าเช็ค can('permission')
export const PermissionProvider = ({ children }) => {
  const [permissions, setPermissions] = useState([]);
  const [profile, setProfile] = useState(null);
  const [loaded, setLoaded] = useState(false);

  const load = async () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        setPermissions([]);
        setProfile(null);
        setLoaded(true);
        return;
      }
      const res = await axios.get(`${API_BASE_URL}/api/users/me`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setProfile(res.data);
      setPermissions(res.data.permissions || []);
    } catch {
      setPermissions([]);
      setProfile(null);
    } finally {
      setLoaded(true);
    }
  };

  useEffect(() => {
    load();
  }, []);

  // เช็คว่ามี permission นี้หรือไม่ (ระดับ ภาค = มีทุกสิทธิ์ — backward compatible)
  const can = (code) => {
    if (profile?.level === 'ภาค') return true;
    return permissions.includes(code);
  };

  return (
    <PermissionContext.Provider value={{ permissions, profile, can, refresh: load, loaded }}>
      {children}
    </PermissionContext.Provider>
  );
};

export const usePermission = () => useContext(PermissionContext);
export default PermissionContext;
